import { PAGE_STATE_PRE_EVENT, PAGE_STATE_CHECK_IN, PAGE_STATE_DURING_EVENT } from 'common/constants/virtualEvent';
import convertLegacyToEngine from '../../VirtualEventRenderer/utils/convertLegacyToEngine';
import { getMigrationFlags, shouldMigratePageState } from '../../VirtualEventRenderer/utils/getMigrationFlags';

/**
 * This function converts the legacy VEP data structure to the new Splash CMS Engine data structure
 *
 * @param {object} settings - The virtual event settings
 * @param {string} elementConfigs - The previous element configs being transformed
 *
 * @returns {object} - The new data engine structure OR an empty object if the legacy data structure is not valid
 */

export const migrateEngine = (settings, elementConfigs) => {
    const engineSettings = settings?.engine || {};
    const isEngineStatesEmpty =
        !engineSettings.states || (Array.isArray(engineSettings.states) && !engineSettings.states.length);

    if (isEngineStatesEmpty) {
        engineSettings.states = {};
    }

    const migrationFlags = getMigrationFlags();

    const shouldMigratePreEvent = shouldMigratePageState(
        PAGE_STATE_PRE_EVENT,
        engineSettings?.states?.[PAGE_STATE_PRE_EVENT]?.migrated,
    );
    const shouldMigrateCheckIn = shouldMigratePageState(
        PAGE_STATE_CHECK_IN,
        engineSettings?.states?.[PAGE_STATE_CHECK_IN]?.migrated,
    );
    const shouldMigrateDuringEvent = shouldMigratePageState(
        PAGE_STATE_DURING_EVENT,
        engineSettings?.states?.[PAGE_STATE_DURING_EVENT]?.migrated,
    );

    if (shouldMigratePreEvent) {
        engineSettings.states[PAGE_STATE_PRE_EVENT] = {
            structure: convertLegacyToEngine(elementConfigs[PAGE_STATE_PRE_EVENT], PAGE_STATE_PRE_EVENT),
            migrated: migrationFlags[PAGE_STATE_PRE_EVENT].currentMigrationVersion,
        };
    }
    if (shouldMigrateCheckIn) {
        engineSettings.states[PAGE_STATE_CHECK_IN] = {
            structure: convertLegacyToEngine(elementConfigs[PAGE_STATE_CHECK_IN], PAGE_STATE_CHECK_IN),
            migrated: migrationFlags[PAGE_STATE_CHECK_IN].currentMigrationVersion,
        };
    }
    if (shouldMigrateDuringEvent) {
        engineSettings.states[PAGE_STATE_DURING_EVENT] = {
            structure: convertLegacyToEngine(elementConfigs[PAGE_STATE_DURING_EVENT], PAGE_STATE_DURING_EVENT),
            migrated: migrationFlags[PAGE_STATE_DURING_EVENT].currentMigrationVersion,
        };
    }

    return engineSettings;
};
